
<template>
    <b-card class="guest-invoices-housekeeping-card mt-2" no-body>
        <template #header>
            <span class="guest-invoices-housekeeping-card__header-icon">
                <font-awesome-icon :icon="['fas', 'hotel']" size="lg" />
            </span>
            <span class="guest-invoices-housekeeping-card__header-content">
                <b>{{ displayPropertyName }}</b>
            </span>
        </template>
        <b-card-body>
            <b-row>
                <b-col>
                    <b>HOUSEKEEPER:</b>
                </b-col>
                <b-col cols="auto">
                    <span v-if="!reservationEdit">
                        {{ currentHousekeeper }}
                    </span>
                    <b-form-select
                        v-click-outside="handleOutsideClick"
                        ref="housekeeper"
                        :autofocus="true"
                        :value="housekeeper.current"
                        :options="housekeeperOptions"
                        @change="handleHousekeeperChange"
                        v-else-if="housekeeper.isEdit && selectedCell === 'housekeeper' && reservationEdit"
                    />
                    <span
                        v-else
                        type="button"
                        class="text-primary guest-invoices-housekeeping-card__clickable-cell"
                        @click="editCellHandler('housekeeper')"
                    >
                        {{ currentHousekeeper }}
                    </span>
                </b-col>
            </b-row>
            <b-row v-if="houseKeeperId">
                <b-col>
                    <b>CLEAN ON:</b>
                </b-col>
                <b-col cols="auto">
                    <span v-if="!reservationEdit">
                        {{ cleanOnDisplayValue }}
                    </span>
                    <form-datepicker
                        v-click-outside="handleOutsideClick"
                        v-else-if="cleanOn.isEdit && selectedCell === 'cleanOn' && reservationEdit"
                        ref="cleanOn"
                        :no-gutters="true"
                        :hide-header="true"
                        :min="reservation.to_date"
                        v-model="techReservation.house_keeping_job.schedule_dt"
                        :display-format="userUnicodeDateFormat"
                        @input="handleCleanOnChange"
                    ></form-datepicker>
                    <span
                        v-else
                        type="button"
                        class="text-primary guest-invoices-housekeeping-card__clickable-cell"
                        @click="editCellHandler('cleanOn')"
                    >
                        {{ cleanOnDisplayValue }}
                    </span>
                </b-col>
            </b-row>
            <b-row v-if="houseKeeperId">
                <b-col>
                    <b>TASK:</b>
                </b-col>
                <b-col cols="auto">
                    <span v-if="!reservationEdit">
                        {{ currentTask }}
                    </span>
                    <b-form-select
                        v-click-outside="handleOutsideClick"
                        ref="task"
                        :autofocus="true"
                        v-model="techReservation.house_keeping_job.job_type"
                        :options="taskOptions"
                        @change="handleTaskChange"
                        v-else-if="task.isEdit && selectedCell === 'task' && reservationEdit"
                    />
                    <span
                        v-else
                        type="button"
                        class="text-primary guest-invoices-housekeeping-card__clickable-cell"
                        @click="editCellHandler('task')"
                    >
                        {{ currentTask }}
                    </span>
                </b-col>
            </b-row>
            <b-row v-if="houseKeeperId">
                <b-col>
                    <b>STATUS:</b>
                </b-col>
                <b-col cols="auto">
                    <span v-if="!reservationEdit">
                        {{ currentStatus }}
                    </span>
                    <b-form-select
                        v-click-outside="handleOutsideClick"
                        ref="status"
                        :autofocus="true"
                        v-model="techReservation.house_keeping_job.job_status"
                        :options="statusOptions"
                        @change="handleStatusChange"
                        v-else-if="status.isEdit && selectedCell === 'status' && reservationEdit"
                    />
                    <span
                        v-else
                        type="button"
                        class="text-primary guest-invoices-housekeeping-card__clickable-cell"
                        @click="editCellHandler('status')"
                    >
                        {{ currentStatus }}
                    </span>
                </b-col>
            </b-row>
            <b-row v-if="houseKeeperId">
                <b-col
                    ><b>COMMENTS TO<br />HOUSEKEEPER:</b></b-col
                >
            </b-row>
            <b-row v-if="houseKeeperId">
                <b-col>
                    <span v-if="!reservationEdit">
                        {{ techReservation.house_keeping_job.instructions }}
                        <span v-if="!techReservation.house_keeping_job.instructions" class="text-danger"> None </span>
                    </span>
                    <b-form-textarea
                        ref="commentsToHousekeeper"
                        v-click-outside="handleCommentsToHousekeeperOutsideClick"
                        v-else-if="
                            commentsToHousekeeper.isEdit && selectedCell === 'commentsToHousekeeper' && reservationEdit
                        "
                        type="text"
                        v-model="techReservation.house_keeping_job.instructions"
                    />
                    <span
                        v-else
                        type="button"
                        class="text-primary guest-invoices-housekeeping-card__clickable-cell"
                        @click="editCellHandler('commentsToHousekeeper')"
                    >
                        {{ techReservation.house_keeping_job.instructions }}
                        <span v-if="!techReservation.house_keeping_job.instructions" class="text-danger"> None </span>
                    </span>
                </b-col>
            </b-row>
            <b-row v-if="houseKeeperId">
                <b-col
                    ><b>COMMENTS FROM<br />HOUSEKEEPER:</b></b-col
                >
            </b-row>
            <b-row v-if="houseKeeperId">
                <b-col>
                    <span>
                        {{ techReservation.house_keeping_job.comments }}
                        <span v-if="!techReservation.house_keeping_job.comments"> None </span>
                    </span>
                </b-col>
            </b-row>
            <b-row v-if="!isNil(damageNoticeModalData.id)">
                <b-col
                    ><b>DAMAGE NOTICE:</b></b-col
                >
                <b-col cols="auto">
                    <span type="button" class="text-primary underline" @click="showDamageNotice">
                        <font-awesome-icon :icon="['fas', 'house-chimney-crack']" size="lg" />
                    </span>
                </b-col>
            </b-row>
            <damage-notice-modal
                :busy="isDamageNoticeModalLoading"
                @create-work-order="onCreateWorkOrder"
                :create-work-order-button="workOrderAdd && !damageNoticeModalData.workOrderId"
                :description="damageNoticeModalData.description"
                :modal-id="damageNoticeModalData.id"
                :photos="damageNoticeModalData.photos"
                @print="onPrintDamageNotice"
                print-damage-notice-button
                :show-work-order-button="!!damageNoticeModalData.workOrderId"
                @show-work-order="onShowWorkOrder"
            />
            <modal
                :id="workOrderCreationConfirmationModalId"
                hide-backdrop
                ok-title="Create"
                title="Work Order Creation Confirmation"
                @ok="onConfirmCreationWorkOrder"
            >
                Are you sure you want to create a new work order based on this damage notice?
            </modal>
        </b-card-body>
    </b-card>
</template>

<script>
import { saveAs } from 'file-saver';
import isNil from 'lodash/isNil';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import { mapGetters } from 'vuex';
import API from '../../../../../api.jsx';
import FormDatepicker from '../../../../generic/form-datepicker/form-datepicker.vue';
import {
    GUEST_HOUSEKEEPING_DAMAGE_NOTICE_CREATE_WORK_ORDER_ENDPOINT,
    GUEST_HOUSEKEEPING_DAMAGE_NOTICE_ENDPOINT,
    GUEST_HOUSEKEEPING_ENDPOINT
} from '../../../../../endpoints';
import Modal from '../../../../generic/modal/modal.vue';
import { convertBlobResponseToJson, formatResponseError, getFilenameFromResponse } from '../../../../../utils/api';
import DamageNoticeModal from '../../../../common/damage-notice-modal.vue';

export default {
    name: 'GuestInvoicesHousekeepingCard',
    components: { FormDatepicker, DamageNoticeModal, Modal },
    props: {
        techReservation: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            selectedCell: null,
            housekeeper: { previous: null, current: null, isEdit: false },
            cleanOn: { previous: null, isEdit: false },
            task: { previous: null, isEdit: false },
            status: { previous: null, isEdit: false },
            commentsToHousekeeper: { previous: null, isEdit: false },
            cleanOnDateFormat: "yyyy-MM-dd'T'12:00:00",
            taskOptions: [
                { value: 0, text: 'Regular Clean' },
                { value: 1, text: 'Half Clean' },
                { value: 2, text: 'Owner Departure Clean' },
                { value: 3, text: 'Out of Service Clean' },
            ],
            statusOptions: [
                { value: 0, text: 'To Do' },
                { value: 1, text: 'In Progress' },
                { value: 2, text: 'Done' },
            ],
            isDamageNoticeModalLoading: false,
        };
    },
    created() {
        this.housekeeper.current = this.houseKeeperId;
    },
    inject: ['showSuccessToast', 'showErrorToast'],
    computed: {
        ...mapGetters('guest', ['metadata', 'reservation']),
        ...mapGetters('header', ['userUnicodeDateFormat']),
        guestId() {
            return parseInt(this.$route.params.id);
        },
        reservationId() {
            return parseInt(this.$route.query.reservation);
        },
        reservationEdit() {
            return this.metadata?.permissions?.reservation_edit;
        },
        workOrderAdd() {
            return this.metadata?.permissions?.work_order_add;
        },
        housekeeperOptions() {
            return [{ value: null, text: 'Not Assigned' }].concat(
                this.techReservation.cleaner_options.map((cleaner) => ({
                    value: cleaner.id,
                    text: cleaner.full_name,
                }))
            );
        },
        currentHousekeeper() {
            return (
                this.housekeeperOptions.find((h) => h.value == this.housekeeper.current)
                    ?.text || 'Not Assigned'
            );
        },
        currentTask() {
            return (
                this.taskOptions.find((t) => t.value == this.techReservation.house_keeping_job?.job_type)?.text ||
                'Not Assigned'
            );
        },
        currentStatus() {
            return (
                this.statusOptions.find((s) => s.value == this.techReservation.house_keeping_job?.job_status)?.text ||
                'Unknown'
            );
        },
        displayPropertyName() {
            return this.techReservation?.room?.name || this.techReservation?.rental_property?.name;
        },
        cleanOnDisplayValue() {
            if (this.techReservation.house_keeping_job?.schedule_dt)
                return format(
                    parseISO(this.techReservation.house_keeping_job?.schedule_dt),
                    this.userUnicodeDateFormat,
                );
            return 'Not Set';
        },
        damageNoticeModalData() {
            return {
                id: this.techReservation.house_keeping_job?.damage_notice?.id
                    ? `damage-notice-modal-id-${this.techReservation.house_keeping_job.damage_notice.id}`
                    : null,
                description: this.techReservation.house_keeping_job?.damage_notice?.description || '',
                workOrderId: this.techReservation.house_keeping_job?.damage_notice?.work_order_id || null,
                photos: this.techReservation.house_keeping_job?.damage_notice?.photos || [],
            }
        },
        workOrderCreationConfirmationModalId() {
            return `work-order-creation-confirmation-modal-id-${this.techReservation.id}`;
        },
        houseKeeperId() {
            return this.techReservation.house_keeping_job?.house_keeper_ids[0] || null;
        },
    },
    methods: {
        isNil,
        handleOutsideClick(event) {
            this.housekeeper.isEdit = false;
            this.cleanOn.isEdit = false;
            this.task.isEdit = false;
            this.status.isEdit = false;
            this.commentsToHousekeeper.isEdit = false;
            this.selectedCell = null;
        },
        handleCommentsToHousekeeperOutsideClick(event) {
            this.commentsToHousekeeper.isEdit = false;
            this.selectedCell = null;
            this.handleCommentsToHousekeeperChange();
        },
        editCellHandler(name) {
            this[name].isEdit = true;
            this.selectedCell = name;
            if (name == 'housekeeper')
                this.housekeeper.previous = this.housekeeper.current;
            if (name == 'cleanOn') this.showCleanOn();
            if (name == 'task') this.task.previous = this.techReservation.house_keeping_job.job_type;
            if (name == 'status') this.status.previous = this.techReservation.house_keeping_job.job_status;
            if (name == 'commentsToHousekeeper') this.showCommentsToHousekeeper();
        },
        showCleanOn() {
            this.cleanOn.previous = this.techReservation.house_keeping_job.schedule_dt;
            this.$nextTick(() => this.$refs.cleanOn.show());
        },
        showCommentsToHousekeeper() {
            this.commentsToHousekeeper.previous = this.techReservation.house_keeping_job.instructions;
            this.$nextTick(() => {
                this.$refs.commentsToHousekeeper.focus();
            });
        },
        formatCleanOnDate(date) {
            return format(parseISO(date), this.cleanOnDateFormat);
        },
        async handleHousekeeperChange(value) {
            this.housekeeper.current = value;
            const previous = this.housekeeper.previous;
            const newHousekeeper = value;
            try {
                this.$emit('loading', true);
                await API.patch(GUEST_HOUSEKEEPING_ENDPOINT(this.techReservation.id), {
                    house_keeper_ids: newHousekeeper === null ? [] : [newHousekeeper],
                });
                this.$emit('refreshReservation', () =>
                    this.showSuccessToast({ text: 'Housekeeper successfully updated.' })
                );
            } catch (e) {
                this.housekeeper.current = previous;
                if (previous !== null)  {
                    this.techReservation.house_keeping_job.house_keeper_ids = [previous];
                }
                const { generic } = formatResponseError(e);
                this.showErrorToast({
                    text: generic || 'Could not change housekeeper.',
                });
            } finally {
                this.$emit('loading', false);
                this.handleOutsideClick();
            }
        },
        async handleCleanOnChange(value) {
            const previous = this.formatCleanOnDate(this.cleanOn.previous);
            const newCleanOn = this.formatCleanOnDate(value);
            try {
                this.$emit('loading', true);
                if (newCleanOn != previous) {
                    await API.patch(GUEST_HOUSEKEEPING_ENDPOINT(this.techReservation.id), {
                        house_keeper_ids: [this.houseKeeperId],
                        schedule_dt: newCleanOn,
                    });
                    this.$emit('refreshReservation', () =>
                        this.showSuccessToast({ text: 'Clean on successfully updated.' })
                    );
                }
            } catch (e) {
                this.techReservation.house_keeping_job.schedule_dt = previous;
                const { generic } = formatResponseError(e);
                this.showErrorToast({
                    text: generic || 'Could not change clean on.',
                });
            } finally {
                this.$emit('loading', false);
                this.handleOutsideClick();
            }
        },
        async handleTaskChange(value) {
            const previous = this.task.previous;
            const newTask = value;
            try {
                this.$emit('loading', true);
                if (newTask != previous) {
                    await API.patch(GUEST_HOUSEKEEPING_ENDPOINT(this.techReservation.id), {
                        house_keeper_ids: [this.houseKeeperId],
                        job_type: newTask,
                    });
                    this.$emit('refreshReservation', () =>
                        this.showSuccessToast({ text: 'Task successfully updated.' })
                    );
                }
            } catch (e) {
                this.techReservation.house_keeping_job.job_type = previous;
                const { generic } = formatResponseError(e);
                this.showErrorToast({
                    text: generic || 'Could not change task.',
                });
            } finally {
                this.$emit('loading', false);
                this.handleOutsideClick();
            }
        },
        async handleStatusChange(value) {
            const previous = this.status.previous;
            const newStatus = value;
            try {
                this.$emit('loading', true);
                if (newStatus != previous) {
                    await API.patch(GUEST_HOUSEKEEPING_ENDPOINT(this.techReservation.id), {
                        house_keeper_ids: [this.houseKeeperId],
                        job_status: newStatus,
                    });
                    this.$emit('refreshReservation', () =>
                        this.showSuccessToast({ text: 'Status successfully updated.' })
                    );
                }
            } catch (e) {
                this.techReservation.house_keeping_job.job_status = previous;
                const { generic } = formatResponseError(e);
                this.showErrorToast({
                    text: generic || 'Could not change status.',
                });
            } finally {
                this.$emit('loading', false);
                this.handleOutsideClick();
            }
        },
        async handleCommentsToHousekeeperChange() {
            const previous = this.commentsToHousekeeper.previous;
            const newCommentsToHousekeeper = this.techReservation.house_keeping_job.instructions;
            try {
                this.$emit('loading', true);
                if (newCommentsToHousekeeper != previous) {
                    await API.patch(GUEST_HOUSEKEEPING_ENDPOINT(this.techReservation.id), {
                        house_keeper_ids: [this.houseKeeperId],
                        instructions: newCommentsToHousekeeper,
                    });
                    this.$emit('refreshReservation', () =>
                        this.showSuccessToast({ text: 'Comments to housekeeper successfully updated.' })
                    );
                }
            } catch (e) {
                this.techReservation.house_keeping_job.instructions = previous;
                const { generic } = formatResponseError(e);
                this.showErrorToast({
                    text: generic || 'Could not change comments to housekeeper.',
                });
            } finally {
                this.$emit('loading', false);
                this.handleOutsideClick();
            }
        },
        showDamageNotice() {
            this.$bvModal.show(this.damageNoticeModalData.id);
        },
        onCreateWorkOrder() {
            this.$bvModal.show(this.workOrderCreationConfirmationModalId);
        },
        onShowWorkOrder() {
            window.location = `/app/work-orders/list/?work_order_id=${this.damageNoticeModalData.workOrderId}`
        },
        async onConfirmCreationWorkOrder() {
            try {
                this.isDamageNoticeModalLoading = true;
                await API.post(
                    GUEST_HOUSEKEEPING_DAMAGE_NOTICE_CREATE_WORK_ORDER_ENDPOINT(this.techReservation.id),
                );
                this.$bvModal.hide(this.damageNoticeModalData.id);
                this.$emit('refreshReservation', () =>
                    this.showSuccessToast({ text: 'Work order successfully created.' })
                );
            } catch (e) {
                const { generic } = formatResponseError(e);
                this.showErrorToast({ text: generic || 'Could not create work order.' });
            } finally {
                this.isDamageNoticeModalLoading = false;
            }
        },
        async onPrintDamageNotice() {
            try {
                this.isDamageNoticeModalLoading = true;
                const response = await API.get(
                    GUEST_HOUSEKEEPING_DAMAGE_NOTICE_ENDPOINT(this.techReservation.id),
                    { responseType: 'blob' }
                );
                saveAs(response.data, getFilenameFromResponse(response));
            } catch (e) {
                if (e.response) {
                    e.response.data = await convertBlobResponseToJson(e.response);
                }
                const { generic } = formatResponseError(e);
                this.showErrorToast({ text: generic || 'Could not download damage notice pdf.' });
            } finally {
                this.isDamageNoticeModalLoading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../../../../scss/bootstrap-extended/bootstrap-extended.scss';

:deep(.ag-root-wrapper) {
    overflow: visible;
}

:deep(.card-body) {
    padding: 1rem !important;
}

:deep(.row) {
    padding: 0.3rem !important;
}

:deep(.col) {
    align-self: center !important;
}

:deep(.form-group) {
    margin-bottom: 0px !important;
}

.guest-invoices-housekeeping-card {
    border: none !important;
    height: 100%;

    > :deep(.card-header) {
        background: linear-gradient(118deg, rgba($primary, 1), rgba($primary, 0.7));
        background-color: transparent !important;
        box-shadow: 0 0 10px 1px rgba($primary, 0.4);
        color: #fff;
        align-items: center;
        padding: 0 !important;
        justify-content: left !important;
        min-height: 50px;
    }
    &__header-icon {
        font-size: 13px;
        margin-left: 1.5rem;
    }

    &__header-content {
        padding-left: 1rem !important;
    }

    &__log {
        display: inline-block;
        width: 100%;
        font-size: 80%;
    }

    @include media-breakpoint-up(md) {
        margin-right: 0.5rem;
    }

    &__clickable-cell {
        text-decoration: underline;
    }

    & .underline {
        border-bottom: 1px solid;
    }
}
</style>
